// External URLs
export const SOCIAL_MEDIA = {
  INSTAGRAM: "https://www.instagram.com/dr.takhuynh.dc/",
  YELP: "https://www.yelp.com/biz/south-bay-rehab-and-performance-cupertino-5",
  GOOGLE: "https://www.google.com/search?hl=en-US&gl=us&q=South+Bay+Rehab+and+Performance,+21629+Stevens+Creek+Blvd,+Cupertino,+CA+95014&ludocid=2591568071588085950&lsig=AB86z5V4qEBt6z_a03fT7OKh5Ryw#lrd=0x808fb58e41eadc7b:0x23f7196e2e4080be,1"
}

// Jane App Booking URLs
export const BOOKING_URLS = {
  NEW_PATIENT: "https://southbayrandp.janeapp.com/#/staff_member/1/treatment/1",
  FOLLOW_UP: "https://southbayrandp.janeapp.com/#/staff_member/1/treatment/2",
  ADJUSTMENT_ONLY: "https://southbayrandp.janeapp.com/#/staff_member/1/treatment/3",
  CUPPING_BLADING: "https://southbayrandp.janeapp.com/#/staff_member/1/treatment/6",
  CONSULT: "https://southbayrandp.janeapp.com/#/staff_member/1/treatment/9"
}

// YouTube Video URLs
export const YOUTUBE_VIDEOS = {
  VIDEO_1: "https://www.youtube.com/embed/XuJrAW6WviA",
  VIDEO_2: "https://www.youtube.com/embed/8HtLzUKauc4",
  VIDEO_3: "https://www.youtube.com/embed/xYx4YhXftmE"
}

// Contact Information
export const CONTACT_INFO = {
  EMAIL: "takhuynhmovement@gmail.com",
  PHONE: "+1 (650) 564-3538",
  ADDRESS: "21629 Stevens Creek Boulevard, Cupertino, CA 95014 (USA)"
}

// Navigation Sections
export const NAV_SECTIONS = [
  { id: 'home', label: 'Home' },
  { id: 'about', label: 'About' },
  { id: 'clinic-information', label: 'Clinic Information' },
  { id: 'services-scheduler', label: 'Services & Scheduler' },
  { id: 'videos', label: 'Videos' },
  { id: 'testimonials', label: 'Testimonials' }
]

// Clinic Name
export const CLINIC_NAME = "South Bay Rehab and Performance"
